"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventShortTermDialogOpening = preventShortTermDialogOpening;
var queryString = require("query-string");
function preventShortTermDialogOpening() {
  // Prevent Short-Term dialogs from reopening on page-load
  var dialogKeys = ['pwaDialogNested', 'pwaDialog', 'pwaOverlay'];
  var PWA_DIALOG_REGEX = /pwaDialog\w*=[^&]*&?/g;
  if (typeof history !== 'undefined') {
    var query = queryString.parse(location.search);
    var hasPwaDialog = Object.keys(query).some(function (key) {
      return dialogKeys.indexOf(key) >= 0;
    });
    if (hasPwaDialog) {
      var urlSansDialog = location.toString().replace(PWA_DIALOG_REGEX, '');
      history.replaceState(null, document.title || '', urlSansDialog);
    } else {
      // re-initialize the history stack for some weird bug on iOS coming from Trivago or Kayak
      history.replaceState(history.state || {}, document.title || '');
    }
  }
}